<script lang="ts">
  import type { DeselectAllConfiguration, DeselectAllOptions } from "../nextBestAction/type";

  interface Props extends DeselectAllConfiguration, DeselectAllOptions {}

  const { rule, sortKey, text, onclick, onsubmit, fontSize = "75", interactive = false }: Props = $props();
</script>

<form
  class="hc_deselectAll ts_hc_forceFormSubmit"
  data-ts-feature-status="deleted"
  action="/grasshopper/filter/resolve"
  method="post"
  {onsubmit}
>
  <input type="hidden" name="rule" value={rule} />
  <input type="hidden" name="sortiertnach" value={sortKey} />
  <button
    class={[
      "hc_deselectAll__submit",
      `hc_deselectAll__submit--${fontSize}`,
      { "hc_deselectAll__submit--interactive": interactive },
    ]}
    type="submit"
    {onclick}>{text}</button
  >
</form>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .hc_deselectAll {
    text-align: right;
    font: var(--label-font);

    &__submit {
      &--75 {
        font: tokens.$oc-semantic-font-copy-75;
      }

      &--100 {
        font: tokens.$oc-semantic-font-copy-100;
      }
      color: tokens.$oc-semantic-color-text-secondary;
      &--interactive {
        color: tokens.$oc-semantic-color-text-interactive;
      }
      background: inherit;
      border: none;
      cursor: pointer;
      padding: 0;
    }
  }
</style>
